import React from 'react';

import BuildZolaRegistryCTA from '../../../components/BuildZolaRegistryCTA';
import SectionContainer from '../SectionContainer/SectionContainer';
import AddExternalSection from '../AddExternalSection/AddExternalSection';

import styles from './ProductCategoriesSection.module.less';

const tileContent = [
  {
    dek: 'Up Your Cooking Game',
    ctaText: 'Add Kitchen',
    imgUrl: 'https://images.zola.com/b936d2eb-065b-418b-8975-c0847e6e380b?w=354',
    imgAltText: 'allclaid-10piece-cookware',
  },
  {
    dek: 'Serve Guests in Style',
    ctaText: 'Add Tabletop',
    imgUrl: 'https://images.zola.com/057b9414-e3c2-49b6-8e30-49c06e5097a3?w=354',
    imgAltText: 'crate-and-barrel-aria-napkin',
  },
  {
    dek: 'Create the Coziest Oasis',
    ctaText: 'Add Bed & Bath',
    imgUrl: 'https://images.zola.com/effc2edd-b7d0-459b-aeb2-8f83476d702e?w=354',
    imgAltText: 'matouk-chatham-blanket',
  },
  {
    dek: 'Bring Your Dreams to Life',
    ctaText: 'Add Honeymoon & Cash Funds',
    imgUrl: '//d35uzl96cmnmq2.cloudfront.net/processed/Resort_A_750.jpg',
    imgAltText: 'honeymoon-resory',
  },
  {
    dek: 'Make Your Home Yours',
    ctaText: 'Add Decor',
    imgUrl: 'https://images.zola.com/66638c14-5930-46ca-a119-335deabf47a1?w=354',
    imgAltText: 'creativecoop-agave-plant',
  },
  {
    dek: 'Furnish Your Newlywed Home',
    ctaText: 'Add Furniture',
    imgUrl: 'https://cdn.shopify.com/s/files/1/0251/6364/products/TOV-S6165_900x.jpg?v=1593893635',
    imgAltText: 'crate-and-barrel-aria-napkin',
  },
  {
    dek: 'Enjoy Weekends Together',
    ctaText: 'Add the Fun Stuff',
    imgUrl: 'https://images.zola.com/7a7ab601-a250-4ab5-a512-39f1ee303a75?w=354',
    imgAltText: 'houndstooth-loungbed',
  },
  {
    dek: 'Make Unforgettable Memories',
    ctaText: 'Add Experiences & Gift Cards',
    imgUrl: 'https://images.zola.com/d5782be3-04d8-4364-8113-e1d594e5aa4d?w=354',
    imgAltText: 'dallas-dining-tour',
  },
];

const ProductTile = ({ content }) => {
  const { dek, ctaText, imgUrl, imgAltText } = content;
  return (
    <div className={styles.tile}>
      <img src={imgUrl} alt={imgAltText} />

      <div className={styles.ctaContainer}>
        <p className={styles.dek}>{dek}</p>
        <BuildZolaRegistryCTA component="Link" ctaText={ctaText} />
      </div>
    </div>
  );
};

const ProductCategoriesSection = () => {
  return (
    <SectionContainer className={styles.sectionColor}>
      <div className={styles.productCategories}>
        <h3>Our Store Has Everything Couples Want</h3>
        <div className={styles.tileContainer}>
          {tileContent.map((c, i) => (
            <ProductTile key={`product-categories-tile-${i}`} content={c} />
          ))}
        </div>
      </div>
      <AddExternalSection />
    </SectionContainer>
  );
};

export default ProductCategoriesSection;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/components/ProductCategoriesSection/ProductCategoriesSection.jsx